import { theme } from '../common/themes'

export const Footer = () => {
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: theme.background,
        fontFamily: theme.font,
        fontSize: '10.5px',
        color: theme.grad8,
        padding: '10px 20px 20px 20px',
      }}
    >
      <div>
        <p>
          Mockstream is intended for use in development and testing environments only, and not for
          production use. Mockstream is provided: (a) without support; (b) "AS IS"; and (c) without
          indemnification, warranty, or condition of any kind. No service level commitment will
          apply to Mockstream. Confluent may discontinue providing access to Mockstream at any time
          in Confluent's sole discretion.
        </p>
      </div>
    </div>
  )
}

export default Footer